import type { FormSchema } from './schema'
import { zodResolver } from '@hookform/resolvers/zod'
import { ZodSchema } from 'zod'

export default (schema: ZodSchema<FormSchema>) => {
  return zodResolver(schema)
}
